import { useEffect, useRef, useState } from "react";
import { locationAPI } from "../../api/locationAPI";

export default function LocationTypeSearch({ setLocCode, setLocName, pCode, setIsAllLocationsChecked }) {
    const [allLocations, setAllLocations] = useState([]);

    const isFirstRender = useRef(false);


    const getLocations = (searchKey = '') => {
        locationAPI.getLocations(pCode, searchKey).then((data) => {
            setAllLocations(data);
        })
    }

    const handleRowSelect = (code, name) => {
        setLocCode(code);
        setLocName(name);
        setIsAllLocationsChecked(false);
    }

    useEffect(() => {
        if (!isFirstRender.current) {
            isFirstRender.current = true;
            getLocations();
        }
    }, [])

    return (
        <div className="modal fade" id="locationTypeSearch" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Location</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                        <input type="text" className="form-control" placeholder="Search by code or name"
                            onChange={(e) => getLocations(e.target.value)} />
                        <table className="table mt-1">
                            <thead className="thead--color">
                                <tr>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allLocations && allLocations.map(data => (
                                    <tr key={data.locCode}>
                                        <td>{data.locCode}</td>
                                        <td>{data.locName}</td>
                                        <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                            onClick={() => handleRowSelect(data.locCode, data.locName)} data-bs-dismiss="modal">
                                            Select</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}